(async () => {

  if (!customElements.get('size-guide-trigger')) {
    class SizeGuideTrigger extends HTMLElement {
      constructor() {
        super();

        this.sizeGuide = document.querySelector('size-guide');
        this.triggerBtn = this.querySelector('.size-guide-trigger__button');
        this.initialSizeguideBlock = this.dataset.sizeGuideInitialSizeguideBlock || null;

        this.triggerBtn.addEventListener('click', this.open.bind(this));
      }

      open(event) {
        event.preventDefault();

        if (!this.sizeGuide) return;

        if (this.initialSizeguideBlock) this.sizeGuide.setInitialSizeguideBlock(this.initialSizeguideBlock);

        this.sizeGuide.open();
      }
    }

    window.SizeGuideTrigger = SizeGuideTrigger;
    customElements.define('size-guide-trigger', SizeGuideTrigger);
  }

})();
